import {
  DataCollectionRecord,
  useMarriageIndexSearch,
} from '@ltvco/refresh-lib/hooks';
import { AdvancedSearchURLParams } from '@ltvco/refresh-lib/v2';
import React, { useEffect } from 'react';

interface MarriageIndexesFetcherProps {
  searchData: AdvancedSearchURLParams;
  // eslint-disable-next-line no-unused-vars
  setMarriageIndexesResults: (data: DataCollectionRecord[] | undefined) => void;
}

export function MarriageIndexesFetcher({
  searchData,
  setMarriageIndexesResults: setMarriageIndexesResults,
}: MarriageIndexesFetcherProps) {
  const { marriageIndexResults } = useMarriageIndexSearch(searchData);
  useEffect(() => {
    setMarriageIndexesResults(marriageIndexResults);
  }, [marriageIndexResults, setMarriageIndexesResults]);

  return <React.Fragment />;
}
